import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/set-layout-property.schema.json';

const mapSetLayoutProperty = action => ({
  type: 'LAYOUT_SET',
  payload: {
    value: action.data.value,
    path: action.data.path,
    keep: action.data.keep,
  },
});

const setLayoutProperty = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapSetLayoutProperty(
    validated(interpolate(meta.action, event, context))
  );
};

export default setLayoutProperty;
